import React from 'react';

/**
 * Shared page header — one consistent title row for every screen.
 * Renders the title on the left and action buttons on the right,
 * stacking vertically on small screens (see .page-header in App.css).
 *
 * @param {object}          props
 * @param {React.ReactNode} props.title
 * @param {React.ReactNode} [props.subtitle]  - short helper text under the title
 * @param {React.ReactNode} [props.leading]   - back action or page icon
 * @param {React.ReactNode} [props.meta]      - compact status/context row
 * @param {React.ReactNode} [props.extra]     - actions (buttons) aligned right
 * @param {string}          [props.className]
 */
const PageHeader = ({
  title,
  subtitle,
  leading,
  meta,
  extra,
  className = '',
}) => (
  <div className={`page-header ${className}`.trim()}>
    <div
      className="page-header__main"
      style={{ display: 'flex', alignItems: 'flex-start', gap: 12, minWidth: 0 }}
    >
      {leading && (
        <div className="page-header__leading" style={{ flexShrink: 0 }}>
          {leading}
        </div>
      )}
      <div className="page-header__text">
        <h1 className="page-header__title">{title}</h1>
        {subtitle && <div className="page-header__subtitle">{subtitle}</div>}
        {meta && (
          <div className="page-header__meta" style={{ marginTop: 8 }}>
            {meta}
          </div>
        )}
      </div>
    </div>
    {extra && <div className="page-header__actions">{extra}</div>}
  </div>
);

export default PageHeader;
